import { TableHeadCell } from "@shared/primitive-components"

export const averageSpeedExceedencePercentageHeaderProps = {
  header: `Average speed exceedance`,
  tooltipContent: `The percentage of trips spent above the speed limit in the last 30 days. The average percentage over the speed limit`,
}

export const AverageSpeedExceedencePercentageHeader = () => (
  <TableHeadCell {...averageSpeedExceedencePercentageHeaderProps} />
)
